import { Avatar, Box, Divider, Typography } from '@mui/material';
import { styled } from '@mui/styles';

type Props = {
  name: string;
  profilePictureUrl?: string;
};

export const EmployeeDetailHeader = ({ name, profilePictureUrl }: Props) => {
  return (
    <>
      <Wrapper>
        <StyledAvatar src={profilePictureUrl} />
        <AboutUser>
          <EmployeeName>{name}</EmployeeName>
          <OnboardingStatus>Not onboarded</OnboardingStatus>
        </AboutUser>
      </Wrapper>
    </>
  );
};

const AboutUser = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  paddingBottom: theme.spacing(6),
  paddingTop: theme.spacing(8),
  gap: theme.spacing(6),
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  borderColor: 'rgba(0, 0, 0, 0.2)',
  backgroundColor: 'transparent',
  width: '100%',
  marginBottom: theme.spacing(6),
}));

const AVATAR_SIZE = 89;

const StyledAvatar = styled(Avatar)({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
});

const EmployeeName = styled(Typography)({
  fontSize: '24px',
  fontVariationSettings: '"wght" 700',
  fontFamily: 'Urbanist',
});

const OnboardingStatus = styled(Typography)({
  fontSize: '14px',
  fontVariationSettings: '"wght" 500',
  fontFamily: 'Urbanist',
});
